import { APP } from '../constants/AuthType';
export const isAppAuthSelector = state => {
  return !!(state.config && state.config.authType === APP);
};